// Exports
export default {
	"container": "container_CYfeS",
	"collapsible": "collapsible_NQDjx",
	"singular": "singular_KmFsA",
	"content": "content_Ou2oe",
	"tiny": "tiny_5KZQ9",
	"small": "small_zfbBT",
	"default": "default_rqW7U",
	"huge": "huge_+sd--",
	"dotContainer": "dotContainer_iNnxm",
	"statusDot": "statusDot_XrJhw",
	"red": "red_IVL9h",
	"green": "green_g4mSB",
	"releasePhaseIconContainer": "releasePhaseIconContainer_BFdj4"
};
